// React
import React from 'react';
import classNames from 'classnames';
// Components
import Conditional from '../common/conditional';
import CustomAvatar from '../common/custom-avatar';
import EmptyRtAvatar from '../../components/empty-rt-avatar';
// Styles
import useStyles from './RtAvatar.styles';

const RtAvatar = ({ classes, rtName, rtPhoto }) => {
  const componentClasses = useStyles();

  const showEmpty = !rtName;

  return (
    <div className={classNames(componentClasses.root, classes.root)}>
      <Conditional if={showEmpty}>
        <EmptyRtAvatar />
      </Conditional>
      <Conditional if={!showEmpty}>
        <CustomAvatar
          classes={{
            root: classNames(componentClasses.avatarRoot, classes.avatarRoot),
          }}
          letter={rtName && rtName.charAt(0)}
          src={rtPhoto}
        />
      </Conditional>
    </div>
  );
};

RtAvatar.defaultProps = {
  classes: {},
};

export default RtAvatar;
